import './App.scss';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect } from 'react';
import { Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as userActions from './redux/actions/userActions';
import NotFoundPage from './components/common/NotFoundPage';
import { GuardProvider, GuardedRoute } from 'react-router-guards';
import { routes } from './constants';
import { bindActionCreators } from 'redux';
import { Toaster } from 'react-hot-toast';
import { Dimmer, Loader } from 'semantic-ui-react';
import Header from './components/common/Header';

const App = ({
  history,
  token,
  loading,
  loaded,
  loggedIn,
  setAppLoaded,
  setLoading,
  loginFromToken,
  message,
  current,
}) => {
  useEffect(() => {
    const tokenInLocalStorage = localStorage.getItem('jwt');
    const tokenInRedux = token;
    if (!tokenInLocalStorage) {
      setAppLoaded(true);
      setLoading(false);
    }
    if (tokenInLocalStorage && !tokenInRedux) {
      loginFromToken(tokenInLocalStorage);
    }
  }, [token, history]);

  return (
    loaded && (
      <>
        {loggedIn && <Header />}
        <GuardProvider loading={loading} error={NotFoundPage}>
          <Switch>
            {routes.map(({ route, component, guards, forceRefresh }) => (
              <GuardedRoute
                key={route}
                path={'/' + route}
                exact
                component={component}
                forceRefresh={false}
                guards={guards}
                meta={{ auth: true, loggedIn, current }}
              />
            ))}
          </Switch>
        </GuardProvider>

        <Toaster position="top-center" reverseOrder={false} />
        <Dimmer inverted active={loading} page>
          <Loader inverted content={message} />
        </Dimmer>
      </>
    )
  );
};

const mapStateToProps = state => ({
  user: state.user.token,
  routes: state.user.routes,
  loggedIn: state.user.loggedIn,
  loading: state.user.loading,
  message: state.user.message,
  loaded: state.user.loaded,
  notifications: state.user.notifications,
  current: state.user.user,
});

const mapDispatchToProps = dispatch => ({
  setAppLoaded: bindActionCreators(userActions.setAppLoaded, dispatch),
  setLoading: bindActionCreators(userActions.setLoading, dispatch),
  loginFromToken: bindActionCreators(userActions.loginFromToken, dispatch),
  getSites: bindActionCreators(actions.admin.getSites, dispatch),
  hydrate: bindActionCreators(actions.user.hydrate, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
